import React, { ChangeEvent, FC } from 'react';

import { observer } from 'mobx-react-lite';
import { update } from 'serializr';
import { action } from 'mobx';

import Input from '@vromo/ui/components/Input';
import { Campaign } from 'models';
import { qaLabelCampaigns } from './../../../../../../common-qa-labels/campaigns';

const LOCALE_GOOGLE_ANALYTICS = 'Google Analytics';
const LOCALE_GENERAL_NAME = 'Name';
const LOCALE_GENERAL_ID = 'ID';

export default observer<{ campaign: Campaign }>(function General({ campaign }) {
    return (
        <div>
            {campaign.id && (
                <>
                    <label>{LOCALE_GENERAL_ID}</label>
                    <div style={{ marginBottom: 20 }}>{campaign.id}</div>
                </>
            )}
            <label>{LOCALE_GENERAL_NAME}</label>
            <Input
                data-testid={qaLabelCampaigns.editModal.nameInput}
                value={campaign.name}
                onChange={action(
                    (e: ChangeEvent<HTMLInputElement>) => (campaign.name = e.target.value)
                )}
            />

            <hr />

            <label>{LOCALE_GOOGLE_ANALYTICS}</label>
            <Input
                placeholder="UA-XXXXXX-Y"
                value={campaign?.analytics?.google || ''}
                onChange={action((e: ChangeEvent<HTMLInputElement>) =>
                    update(campaign, { analytics: { google: e.target.value } })
                )}
            />
        </div>
    );
});
